import { render } from "./index.vue?vue&type=template&id=c92d66a4"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/campaigns-edit/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c92d66a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c92d66a4', __exports__)) {
    api.reload('c92d66a4', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=c92d66a4", () => {
    api.rerender('c92d66a4', render)
  })

}


export default __exports__